import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function groupMin(min = 1) {
  return (control: UntypedFormGroup): ValidationErrors => {
    const currentlySelected = Object.entries(control?.value)?.filter(([, value]) => Boolean(value));

    if (!control) return null;
    const invalid = currentlySelected.length < min;
    return invalid ? { groupMin: true } : null;
  };
}
